(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["opiniones-producto"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const carousel = document.getElementById('opiniones-carousel');
    const dots = document.querySelectorAll('.maikai-opiniones__dot');

    if (!carousel || dots.length === 0) return;

    // Actualizar puntos al hacer scroll
    function updateActiveDot() {
      const scrollLeft = carousel.scrollLeft;
      const itemWidth = carousel.querySelector('.maikai-opinion').offsetWidth;
      const currentIndex = Math.round(scrollLeft / (itemWidth + 32)); // 32px es el gap

      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === currentIndex);
      });
    }

    // Scroll al hacer click en los puntos
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        const itemWidth = carousel.querySelector('.maikai-opinion').offsetWidth;
        const scrollPosition = index * (itemWidth + 32);
        carousel.scrollTo({
          left: scrollPosition,
          behavior: 'smooth'
        });
      });
    });

    // Listener para detectar scroll
    carousel.addEventListener('scroll', updateActiveDot);
    carousel.addEventListener('scrollend', updateActiveDot);

    // Fallback si scrollend no existe
    let scrollTimeout;
    carousel.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateActiveDot, 150);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonios"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const carousel = document.getElementById('testimonialsCarousel');
    if (!carousel) return;

    const track = carousel.querySelector('.maikai-testimonios__track');
    const items = carousel.querySelectorAll('.maikai-testimonial:not(.maikai-testimonial--clone)');
    const prevBtn = document.getElementById('carouselPrev');
    const nextBtn = document.getElementById('carouselNext');

    // Determinar items por vista: 1 en pantallas <= 800px, sino usar valor configurado
    let itemsPerView = parseInt(carousel.getAttribute('data-items')) || 1;
    if (window.innerWidth <= 800) {
      itemsPerView = 1;
    }

    const totalItems = items.length;
    const autoplaySpeed = parseInt(carousel.getAttribute('data-autoplay')) || 0;
    const gap = 32;

    let currentIndex = 0;
    let autoplayInterval = null;

    // Clonar elementos para carrusel infinito
    const clonedItemsStart = [];
    const clonedItemsEnd = [];

    for (let i = 0; i < itemsPerView; i++) {
      const cloneStart = items[totalItems - 1 - i].cloneNode(true);
      cloneStart.classList.add('maikai-testimonial--clone');
      track.insertBefore(cloneStart, track.firstChild);
      clonedItemsStart.unshift(cloneStart);
    }

    for (let i = 0; i < itemsPerView; i++) {
      const cloneEnd = items[i].cloneNode(true);
      cloneEnd.classList.add('maikai-testimonial--clone');
      track.appendChild(cloneEnd);
      clonedItemsEnd.push(cloneEnd);
    }

    let actualIndex = itemsPerView;

    function updateItemWidths() {
      const availableWidth = carousel.offsetWidth;
      const totalGap = gap * (itemsPerView - 1);
      const itemWidth = (availableWidth - totalGap) / itemsPerView;

      // Aplicar ancho a todos los elementos (originales + clones)
      const allItems = track.querySelectorAll('.maikai-testimonial');
      allItems.forEach(item => {
        item.style.width = itemWidth + 'px';
      });

      return itemWidth;
    }

    function updateCarousel(smooth = true) {
      const itemWidth = updateItemWidths();
      const offset = -actualIndex * (itemWidth + gap);
      track.style.transition = smooth ? 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)' : 'none';
      track.style.transform = `translateX(${offset}px)`;
    }

    function goToSlide(index) {
      actualIndex = itemsPerView + index;
      updateCarousel(true);

      // Verificar si necesitamos hacer un salto invisible
      setTimeout(() => {
        if (actualIndex >= totalItems + itemsPerView) {
          actualIndex = itemsPerView;
          updateCarousel(false);
        } else if (actualIndex < itemsPerView) {
          actualIndex = totalItems + itemsPerView - 1;
          updateCarousel(false);
        }
      }, 600);
    }

    function nextSlide() {
      currentIndex = (currentIndex + 1) % totalItems;
      goToSlide(currentIndex);
    }

    function prevSlide() {
      currentIndex = (currentIndex - 1 + totalItems) % totalItems;
      goToSlide(currentIndex);
    }

    function startAutoplay() {
      if (autoplaySpeed > 0) {
        autoplayInterval = setInterval(() => {
          nextSlide();
        }, autoplaySpeed * 1000);
      }
    }

    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }

    // Agregar listeners
    if (prevBtn && nextBtn) {
      nextBtn.addEventListener('click', () => {
        stopAutoplay();
        nextSlide();
        startAutoplay();
      });
      prevBtn.addEventListener('click', () => {
        stopAutoplay();
        prevSlide();
        startAutoplay();
      });
    }

    // Pausa autoplay en hover
    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);

    // Actualizar en resize
    window.addEventListener('resize', () => {
      // Recalcular itemsPerView si cambia el tamaño de pantalla
      const configuredItems = parseInt(carousel.getAttribute('data-items')) || 1;
      if (window.innerWidth <= 800) {
        itemsPerView = 1;
      } else {
        itemsPerView = configuredItems;
      }

      // Ajustar índice actual si es necesario
      if (currentIndex >= totalItems) {
        currentIndex = 0;
      }

      actualIndex = itemsPerView + currentIndex;
      updateCarousel(false);
    });

    // Inicializar
    updateCarousel(false);
    startAutoplay();
  });

  } catch(e) { console.error(e); }
})();
})();
